export default __webpack_public_path__ + "static/up-43673a5b40dcc5ea0d330b2763e618a0.png";